import { render, staticRenderFns } from "./hzbletteredit.vue?vue&type=template&id=67f90ded&"
import script from "./hzbletteredit.vue?vue&type=script&lang=ts&"
export * from "./hzbletteredit.vue?vue&type=script&lang=ts&"
import style0 from "./hzbletteredit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports